<div #navigationButtonContainer class="buttons-container">
    <button #buttonPrev (click)="goPrev()" class="buttons-container__button-prev disabled" [attr.aria-label]="'Anterior' | translate"></button>
    <button #buttonNext (click)="goNext()" class="buttons-container__button-next" [attr.aria-label]="'Siguiente' | translate"></button>
</div>